var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observe, action, observable, extendObservable, toJS, computed } from "mobx";
import { EventsBySportIdRequest } from "sb-bff-integration";
import * as i from "../contracts";
import { FilterPredicate, SubFilterPredicate } from "../typings";
import { EmptyStatisticsData, StreamingFilterBlockConstant } from "../constants";
import { DateRangeMapper, compareArrays, mapStartDateTime, mapMarketsSelectionsOdds, prepareMarkets, mapLinkUrl, mapLeagueUrl, mapIsSelected, mapSelectionsOdds, mapEventComponent, updateLeagueRankID, FavoritesManager, MessageBus, mapStatisticsIcon, mapMBNMarketIcon } from "../helpers";
import { mapKickOffTime } from "../composables/mappers";
import { sortLeagues, sortEventsByTime } from "../composables/sorters";
import Debounce from "debounce-decorator";
import { BsUtilReceivers } from "sb-betslip-utils-contracts";
import { EventModes } from "../data";
import { OutrightSelectionSorter } from "../helpers";
export class Parser {
    constructor(retriever, piper, requstParams, navFunctions, specialLeagues, parserCmsConfig, dict, favoritesManager) {
        this.piper = piper;
        this.retriever = retriever;
        this.dict = dict;
        this.topicPrefix = `${parserCmsConfig.topicPrefix}.`;
        this.clientId = parserCmsConfig.clientId;
        this.data = { events: observable([]), markets: observable([]), leagues: observable([]) };
        this.eventsDisposers = [];
        this.rootDisposers = [];
        this.sports = requstParams.sportIds;
        this.dateRange = requstParams.dateRange;
        this.allSportIds = requstParams.allSportIds;
        this.isFavoritesEnabled = retriever.dataProvider.isFavoritesEnabled;
        this.loader = retriever.loader();
        this.isInFavoritesState = false;
        this.dateFormat = retriever.dataProvider.shortDateFormat;
        this.timeFormat = retriever.dataProvider.shortTimeFormat;
        this.useMonthName = retriever.dataProvider.useMonthName;
        this.filterManager = retriever.filterManager;
        this.activeEventId = "";
        this.activeMarketId = "";
        this.onLogin = this.onLogin.bind(this);
        this.favoritesManager = favoritesManager || new FavoritesManager(`favoriteEvents_${parserCmsConfig.topicPrefix}`);
        this.oddStyle = 0;
        this.timeZone = 0;
        this.mapEventLinkUrl = mapLinkUrl.bind(this, navFunctions.adjustLivePath, navFunctions.adjustPath);
        this.mapLeagueLinkUrl = mapLeagueUrl.bind(this, navFunctions.adjustPath);
        this.mapStatisticsIcon = mapStatisticsIcon.bind(this, parserCmsConfig.showStatisticsIcon);
        this.mapMBNMarketIcon = mapMBNMarketIcon.bind(this, parserCmsConfig.isMBNEnabled);
        this.specialLeagues = specialLeagues;
        this.hasSettlementDate = parserCmsConfig.hasSettlementDate;
        this.sortIPTopLeaguesFirst = parserCmsConfig.sortIPTopLeaguesFirst;
        this.messageBus = new MessageBus(this.topicPrefix, this);
        this.shouldSortEventsByTime = parserCmsConfig.shouldSortEventsByTime;
        this.outrightSelectionSorter = new OutrightSelectionSorter(parserCmsConfig.outrightSortOptions);
        this.piper.appendAll(["mapGameScore", "mapGamePart", "mapEventIcons", "mapParticipants", "mapTeamNames", "mapStatistics", "mapKickOffState", "mapAggregatedEventsCount", "mapGameTime", "filterExpiredOutrights"]);
        this.shouldSortEventsByTime && this.piper.append("sortEventsByTime");
    }
    get isMiniEventCard() {
        return this.retriever.isMiniEventCard;
    }
    ;
    /**
     * Base functions
     */
    activate() {
        this.messageBus.attachListeners();
        this.attachAllObservables();
        this.retriever.activate();
        this.isFavoritesEnabled && this.favoritesManager.loadFavorites();
        this.messageBus.requestGlobalListeners(this.timeZoneChange.bind(this), this.oddStyleChange.bind(this), this.onLogin.bind(this));
    }
    deactivate() {
        this.sports = [];
        this.retriever.deactivate();
        this.dettachAllObservables();
        this.messageBus.dettachListeners();
        this.clearData();
    }
    setParams(sportIds) {
        this.sports = sportIds;
        this.retriever.setParams(sportIds);
    }
    /**
     *  Attach/dettach observers to data
     */
    // TODO: observe only what is shown on the screen
    attachEventObservables() {
        this.eventsDisposers = [
            ...this.retriever.data.events.map(x => observe(x, this.updateSingleEvent)),
            ...this.retriever.data.markets.map(x => observe(x, this.updateSingleMarkets)),
            ...this.retriever.data.leagues.map(x => observe(x, this.updateLeagues)),
        ];
    }
    dettachEventObservables() {
        this.eventsDisposers.forEach(x => typeof x === "function" && x());
        this.eventsDisposers = [];
    }
    attachAllObservables() {
        this.attachEventObservables();
        this.rootDisposers = [
            observe(this.retriever.data.events, this.updateSingleEvent),
            observe(this.retriever.data.markets, this.updateSingleMarkets),
            observe(this.retriever.data.leagues, this.updateLeagues),
            observe(this.piper.pipeline, this.updateSingleEvent)
        ];
        Object.keys(this.retriever.subLoaders).forEach(type => {
            this.rootDisposers.push(observe(this.retriever.subLoaders[type], this.updateLoader));
        });
    }
    dettachAllObservables() {
        this.rootDisposers.forEach(x => typeof x === "function" && x());
        this.rootDisposers = [];
        this.dettachEventObservables();
    }
    getEventMode(event) {
        let isOutright = event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString();
        if (event.isLive) {
            return isOutright ? EventModes.LiveOutright : EventModes.LiveFixture;
        }
        else {
            return isOutright ? EventModes.Outright : EventModes.Fixture;
        }
    }
    /**
     * Internal msg bus handlers
     */
    sportsChange(x) {
        if (!this.isInFavoritesState && compareArrays(x.sportIds, this.sports)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = x.sportIds;
        this.setSubFilterPredicate(SubFilterPredicate.None);
        const shouldUpdateCurrentData = this.isCurrentSportsDataLoaded();
        this.retriever.querySportUpdate(x.sportIds);
        //personalized highlight (for you tab) should reset data
        x.sportIds.length > 1 ? this.retriever.loadedData.clearData() : (shouldUpdateCurrentData && this.updateData());
    }
    leaguesChange(x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.queryLeaguesUpdate(x.leagueIds, this.sports);
    }
    regionsChange(x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.queryRegionIdUpdate(x.regionId, x.sportId);
    }
    datesChange(x) {
        this.isInFavoritesState = false;
        this.dateRange = x.dateRange;
        const shouldUpdateCurrentData = this.isCurrentDatesDataLoaded();
        this.retriever.queryDatesUpdate(this.dateRange, this.sports);
        shouldUpdateCurrentData && this.updateData();
    }
    liveStreamChange() {
        if (this.filterManager.isCurrentMainFilter(FilterPredicate.LiveStreaming)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = this.allSportIds;
        this.dateRange = undefined;
        const shouldUpdateCurrentData = this.isCurrentTagsDataLoaded(EventsBySportIdRequest.EventTagsEnum.LiveStreaming);
        this.retriever.queryTagsUpdate(EventsBySportIdRequest.EventTagsEnum.LiveStreaming);
        shouldUpdateCurrentData && this.updateData();
    }
    favoritesChange() {
        if (this.filterManager.isCurrentMainFilter(FilterPredicate.Favorites)) {
            return;
        }
        this.isInFavoritesState = true;
        this.sports = this.favoritesManager.favoriteSportIds;
        this.dateRange = undefined;
        this.retriever.queryFavoritesUpdate(this.favoritesManager.getFavorites);
    }
    liveStreamingChange() {
        this.setSubFilterPredicate(SubFilterPredicate.LiveStreaming);
    }
    fastMarketsChange() {
        this.setSubFilterPredicate(SubFilterPredicate.FastMarket);
    }
    allEventsChange() {
        this.setSubFilterPredicate(SubFilterPredicate.None);
    }
    marketGroupsChange(msg) {
        if (this.activeMarketId === msg.marketId) {
            return;
        }
        this.dettachEventObservables();
        this.activeMarketId = msg.marketId;
        let markets = this.retriever.data.markets.slice().map(market => (Object.assign({}, market)));
        const cardConfig = this.retriever.cardConfig.getConfig(this.isMiniEventCard);
        let filteredMarkets = this.filterMarkets(prepareMarkets(markets, cardConfig, this.specialLeagues, this.data.events, this.outrightSelectionSorter));
        this.data.markets.replace(this.mapMarkets(filteredMarkets));
        this.attachEventObservables();
    }
    activeEventIdChange(eventId) {
        if (!eventId) {
            return;
        }
        this.activeEventId = eventId;
        this.updateEvents();
    }
    onLogin(user) {
        user && this.retriever.setRegionId(user.CountryOfRegistration);
    }
    onLogout() {
        this.retriever.removeRegionId();
    }
    renewJWTToken() {
        this.retriever.renewJWTToken();
    }
    updateMiniEventCard(isMiniEventCard) {
        this.retriever.isMiniEventCard = isMiniEventCard;
    }
    changedToSide(eventCardMessage) {
        this.updateMiniEventCard(eventCardMessage.changedToSide);
        let cardConfig = this.retriever.cardConfig.getConfig(eventCardMessage.changedToSide);
        if (!eventCardMessage.changedToSide) {
            this.filterManager.setSubPredicate(SubFilterPredicate.None);
            this.data.markets.replace(prepareMarkets(this.data.markets, cardConfig, this.specialLeagues, this.data.events, this.outrightSelectionSorter));
        }
        this.data.events.forEach(ev => {
            mapEventComponent(ev, this.retriever.cardConfig, this.isMiniEventCard);
        });
        if (eventCardMessage.initActiveEvent && !this.activeEventId && this.data.events.length) {
            const firstEvent = this.data.events[0];
            const isOutright = firstEvent.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString();
            this.activeEventId = firstEvent.id;
            this.messageBus.sendActiveEventMessage(this.activeEventId, isOutright);
        }
        let activeEvent = this.data.events.find(e => e.id === this.activeEventId);
        if (activeEvent) {
            this.messageBus.sendLastActiveEventMessage(activeEvent.id, this.getEventMode(activeEvent));
        }
        this.sendTagsMessage(this.data.events);
    }
    betslipAddedItemsReceived(message) {
        this.dettachEventObservables();
        message.items.forEach((item) => {
            let market = this.data.markets.find(m => m.id === item.marketId);
            let selection = market && market.selections.find(s => s.id === item.selectionId);
            selection && (selection.isSelectionInBetslip = true);
        });
        this.attachEventObservables();
    }
    betslipRemovedItemsReceived(message) {
        this.dettachEventObservables();
        message.items.forEach((item) => {
            let market = this.data.markets.find(m => m.id === item.marketId);
            let selection = market && market.selections.find(s => s.id === item.selectionId);
            selection && (selection.isSelectionInBetslip = false);
        });
        this.attachEventObservables();
    }
    betslipClearedItemsReceived() {
        this.dettachEventObservables();
        this.data.markets.forEach(m => {
            m.selections.forEach(s => s.isSelectionInBetslip = false);
        });
        this.attachEventObservables();
    }
    betSlipStatusReceived(message) {
        let selectionIdsInBetslip = message.items.map(item => item.selectionId);
        this.dettachEventObservables();
        this.data.markets.forEach(m => {
            m.selections.forEach(s => s.isSelectionInBetslip = selectionIdsInBetslip.indexOf(s.id) > -1);
        });
        this.attachEventObservables();
    }
    oddStyleChange(oddStyleMsg) {
        this.oddStyle = oddStyleMsg.currentSelectedOddStyle;
        this.dettachEventObservables();
        this.data.markets.replace(mapMarketsSelectionsOdds(this.data.markets, this.oddStyle, this.dict));
        this.attachEventObservables();
    }
    timeZoneChange(timeZoneMsg) {
        this.timeZone = timeZoneMsg.currentSelectedTimeZone;
        this.dettachEventObservables();
        this.updateEventsTimeZone(this.data.events);
        this.attachEventObservables();
    }
    /**
     * Update data collections
     */
    updateEvents() {
        this.dettachEventObservables();
        let events = this.retriever.data.events.slice().map(ev => (Object.assign({}, ev)));
        let filteredEvents = this.filterEvents(events);
        this.data.events.replace(this.mapEvents(this.piper.executePipeline(filteredEvents)));
        this.attachEventObservables();
    }
    updateMarkets() {
        this.dettachEventObservables();
        this.messageBus.sendBsUtilStatusMessage();
        let markets = this.retriever.data.markets.slice().map(m => {
            m.selections = m.selections.slice();
            m.tags = m.tags.slice();
            return Object.assign({}, m);
        });
        let cardConfig = this.retriever.cardConfig.getConfig(this.isMiniEventCard);
        let marketsFiltered = this.filterMarkets(prepareMarkets(markets, cardConfig, this.specialLeagues, this.data.events, this.outrightSelectionSorter));
        this.data.markets.replace(this.mapMarkets(marketsFiltered));
        this.attachEventObservables();
    }
    updateSingleMarkets(change) {
        this.dettachEventObservables();
        let removed = change.removed, added = change.added, cardConfig = this.retriever.cardConfig.getConfig(this.isMiniEventCard);
        this.handleRemove(removed, "markets");
        this.batchedUpdateSingleMarkets(change, cardConfig);
        this.addedMarkets(added, cardConfig);
    }
    mapEvents(events) {
        return events.map((ev) => {
            // add events missing properties
            mapKickOffTime(ev, this.timeZone);
            mapStartDateTime(ev, {
                currentTimeZone: this.timeZone,
                dateFormat: this.dateFormat,
                timeFormat: this.timeFormat,
                useMonthName: this.useMonthName,
                dict: this.dict,
                hasSettlementDate: this.hasSettlementDate
            });
            mapIsSelected(ev, this.activeEventId);
            this.mapEventLinkUrl(ev);
            this.isFavoritesEnabled && (ev.isInFavorites = this.favoritesManager.isInFavorites(ev.id));
            mapEventComponent(ev, this.retriever.cardConfig, this.isMiniEventCard);
            this.mapStatisticsIcon(ev);
            return ev;
        });
    }
    mapMarkets(updatedMarkets) {
        return updatedMarkets.map(m => {
            let sel = mapSelectionsOdds(m.selections, this.oddStyle, this.dict);
            m.selections = sel;
            this.addSelectionBetslipStatusProperty(m);
            this.mapMBNMarketIcon(m);
            return m;
        });
    }
    mapLeagues() {
        this.data.leagues.map((league) => this.mapLeagueLinkUrl(league));
    }
    batchedUpdateSingleMarkets(change, cardConfig) {
        if (change.type === "update") {
            let markets = prepareMarkets([toJS(change.newValue)], cardConfig, this.specialLeagues, this.data.events, this.outrightSelectionSorter);
            let filteredMarkets = this.activeMarketId ? this.filterMarkets(this.mapMarkets(markets)) : this.mapMarkets(markets);
            filteredMarkets.forEach(market => {
                let index = this.data.markets.findIndex(e => e.id === market.id);
                if (index > -1) {
                    let oldMarket = this.data.markets[index];
                    let selectedIds = Array();
                    oldMarket.selections.forEach(s => s.isSelectionInBetslip && s.metadata.idSBTech && (selectedIds.push(s.metadata.idSBTech)));
                    selectedIds.length && market.selections.forEach(s => s.isSelectionInBetslip = selectedIds.indexOf(s.metadata.idSBTech) > -1);
                    this.data.markets[index] = market;
                }
            });
        }
    }
    addedMarkets(added, cardConfig) {
        if (added) {
            let addedMarkets = prepareMarkets(added.map(market => (Object.assign({}, market))), cardConfig, this.specialLeagues, this.data.events, this.outrightSelectionSorter);
            addedMarkets = this.activeMarketId
                ? this.filterMarkets(this.mapMarkets(addedMarkets))
                : this.mapMarkets(addedMarkets);
            this.data.markets = this.data.markets.concat(addedMarkets.slice(0));
            this.messageBus.sendBsUtilStatusMessage();
        }
    }
    updateLoader() {
        this.loader = this.retriever.loader();
        if (!this.loader.isLoading && this.loader.isFullLoadFinished) {
            const filteredEvents = this.filterEvents(this.retriever.data.events.slice());
            this.sendEventsCountMessage(filteredEvents.length);
            this.sendTagsMessage(filteredEvents);
        }
    }
    updateLeagues() {
        this.dettachEventObservables();
        let leagues = this.retriever.data.leagues.slice();
        let regions = this.retriever.activeRequests.fixtures ?
            this.retriever.activeRequests.fixtures.request.regionIds :
            (this.retriever.activeRequests.outrights ? this.retriever.activeRequests.outrights.request.regionIds : []);
        if (this.sortIPTopLeaguesFirst) {
            leagues = leagues.map(league => {
                let isFromRegion = regions && regions.indexOf(league.regionId) >= 0;
                updateLeagueRankID(league, isFromRegion);
                return league;
            });
        }
        let topLeagues = leagues.filter(league => league.isTopLeague ||
            regions && regions.indexOf(league.regionId) >= 0);
        let notTopLeagues = leagues.filter(league => !(league.isTopLeague ||
            (regions && regions.indexOf(league.regionId) >= 0)));
        this.data.leagues.replace(topLeagues.sort(sortLeagues).concat(notTopLeagues.sort(sortLeagues)));
        this.mapLeagues();
        this.attachEventObservables();
    }
    updateEventsTimeZone(events) {
        this.data.events.replace(events.map((event) => mapStartDateTime(event, {
            currentTimeZone: this.timeZone,
            dateFormat: this.dateFormat,
            timeFormat: this.timeFormat,
            useMonthName: this.useMonthName,
            dict: this.dict,
            hasSettlementDate: this.hasSettlementDate
        })));
    }
    managedEvents(events) {
        let filteredEvents = this.filterEvents(events);
        let eventsToUpdate = this.mapEvents(this.piper.executePipeline(filteredEvents));
        return eventsToUpdate;
    }
    singleEventUpdate(change) {
        let hasUpdate = false;
        if (change.type === "update") {
            let events = this.managedEvents([toJS(change.newValue)]);
            events.forEach(ev => {
                let index = this.data.events.findIndex(e => e.id === ev.id);
                let hasEvent = index > -1;
                if (hasEvent) {
                    let startEventDate = this.data.events[index].startEventDate;
                    hasUpdate = ev.startEventDate !== startEventDate;
                    this.data.events[index] = ev;
                }
            });
        }
        return hasUpdate;
    }
    singleEventAddUpdate(added) {
        if (added) {
            let addedEvents = this.managedEvents(added.map(ev => (Object.assign({}, ev))));
            addedEvents.forEach(ev => this.data.events.push(ev));
            return true;
        }
        return false;
    }
    updateSingleEvent(change) {
        let removed = change.removed, added = change.added;
        this.handleRemove(removed, "events");
        let shouldSortEvents = this.singleEventUpdate(change);
        shouldSortEvents = shouldSortEvents || this.singleEventAddUpdate(added);
        if (this.shouldSortEventsByTime && shouldSortEvents) {
            this.data.events.replace(this.data.events.slice().sort(sortEventsByTime));
        }
    }
    addSelectionBetslipStatusProperty(market) {
        market.selections = market.selections.map((selection) => {
            selection.isSelectionInBetslip === undefined && extendObservable(selection, {
                isSelectionInBetslip: false
            });
            return selection;
        });
    }
    handleRemove(collection, type) {
        if (collection) {
            collection.forEach(el => {
                this.data[type].splice(this.data[type].findIndex(x => x.id === el.id), 1);
            });
        }
    }
    /**
     * Filter data collections
     */
    filterEvents(events) {
        let to = this.dateRange && this.dateRange.from ? DateRangeMapper[this.dateRange.timeRange](this.dateRange.from) : "";
        let ids = this.filterManager.getMainPredicate() === FilterPredicate.Favorites ? this.favoritesManager.favoriteEventIds : this.sports;
        let filterFn = this.filterManager.filterEntity.bind(this.filterManager, ids, this.dateRange && this.dateRange.from, to);
        let filteredEvents = events.filter(filterFn);
        return filteredEvents;
    }
    filterMarkets(markets) {
        // activeMarketId is being set to -1, when no filtration should be applied
        if (!this.activeMarketId || this.activeMarketId === "-1") {
            return markets;
        }
        return markets.filter(this.retriever.filterByMarketId.bind(this.retriever, this.activeMarketId));
    }
    setSubFilterPredicate(newFilter) {
        if (this.filterManager.isCurrentSubFilter(newFilter)) {
            return;
        }
        this.isInFavoritesState = false;
        this.dateRange = undefined;
        this.filterManager.setSubPredicate(newFilter);
        this.updateEvents();
    }
    /**
     * Send messages via msg bus
     */
    sendEventsCountMessage(count) {
        let sport = this.filterManager.getMainPredicate() === FilterPredicate.LiveStreaming || this.sports.length === 0 ?
            StreamingFilterBlockConstant : this.sports[0];
        this.messageBus.sendEventCountMessage(count, sport);
    }
    sendTagsMessage(events) {
        let hasLiveStreamEvents = false;
        let hasFastMarketsEvents = false;
        for (let i = 0; i < events.length; i += 1) {
            const ev = events[i];
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString()) > -1 && (hasLiveStreamEvents = true);
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.FastMarket.toString()) > -1 && (hasFastMarketsEvents = true);
            if (hasLiveStreamEvents && hasFastMarketsEvents) {
                break;
            }
        }
        const result = { hasLiveStreamEvents, hasFastMarketsEvents };
        this.messageBus.sendTagsMessage(result);
        return result;
    }
    sendBsUtilItemsAddMessage(items) {
        this.messageBus.sendBsUtilItemsAddMessage({
            receiverIds: [BsUtilReceivers.FullBetSlip],
            items
        });
    }
    sendBsUtilItemsRemoveMessage(items) {
        this.messageBus.sendBsUtilItemsRemoveMessage({
            receiverIds: [BsUtilReceivers.FullBetSlip],
            items
        });
    }
    /**
     * Handlers triggered from State
     */
    manageFavorites(event) {
        event.isInFavorites = !event.isInFavorites;
        this.favoritesManager.manageFavorites(event);
    }
    getOpenGameData(event, ev) {
        if (!event) {
            return;
        }
        return {
            event: ev,
            id: parseInt(event.id),
            isLive: event.isLive,
            evTypeForGameBlock: this.getEventMode(event),
            shouldHideSidePanels: false,
            branchID: parseInt(event.sportId)
        };
    }
    openStats(statisticsEventId, e) {
        let statData = this.getStatisticsData(statisticsEventId);
        this.retriever.dataProvider.statisticsProvider.openStats(statData, e);
    }
    openLiveStream(eventId) {
        this.messageBus.sendLiveStreamMessage(eventId);
    }
    getStatisticsData(statisticsEventId) {
        return Object.assign(Object.assign({}, EmptyStatisticsData), { betRadarData: {
                clientId: this.clientId,
                eventId: statisticsEventId
            } });
    }
    /**
     * Store retrieved data helpers
     */
    isCurrentSportsDataLoaded() {
        return (!this.retriever.data.events.length || this.retriever.loadedData.containsSportIds(this.sports));
    }
    isCurrentDatesDataLoaded() {
        const date = this.dateRange && this.dateRange.from ? this.dateRange.from : new Date();
        return this.retriever.loadedData.containsSportIdsAndDate(this.sports, date);
    }
    isCurrentTagsDataLoaded(tag) {
        return this.retriever.loadedData.containsTag(tag);
    }
    getCardConfigBySportId(id, isMiniEventCard) {
        return this.retriever.cardConfig.getCardConfigBySportId(id, isMiniEventCard);
    }
    clearData() {
        this.data = { events: observable([]), markets: observable([]), leagues: observable([]) };
    }
    updateData() {
        this.updateEvents();
        this.updateMarkets();
        this.updateLeagues();
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "data", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "sports", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "dateRange", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "oddStyle", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "timeZone", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Parser.prototype, "isInFavoritesState", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "loader", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Parser.prototype, "isMiniEventCard", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "activate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "deactivate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "sportsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "leaguesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "regionsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "datesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "liveStreamChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "favoritesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "liveStreamingChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "fastMarketsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "allEventsChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "marketGroupsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "activeEventIdChange", null);
__decorate([
    Debounce,
    __metadata("design:type", Object)
], Parser.prototype, 249, void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "changedToSide", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipAddedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipRemovedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipClearedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betSlipStatusReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "oddStyleChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "timeZoneChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateEvents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateMarkets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateSingleMarkets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "mapEvents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "mapMarkets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "mapLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateLoader", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateLeagues", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateSingleEvent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "manageFavorites", null);
//# sourceMappingURL=parser.js.map